GraphQL ID: templates
list:

  - class: Mesmer
    builds:

      - name: Power Troubadour
        id: ptroub
        specialization: Troubadour
        boonType: Power
        priority: Power DPS (no dragon)
        distribution: Power Troubadour
        traits: Power Troubadour
        fractal:
          extras: Power (Fractal, claw)
        raid:
          extras: Power (Raid, claw)
        weaponType: Two-handed
        outdated: true

      - name: Condi Virtuoso Dueling
        id: cvirt
        specialization: Virtuoso
        boonType: Condi
        priority: Condi DPS Rampager
        distribution: Condi Virtuoso Dueling
        traits: Condi Virtuoso Dueling
        extras: Condi Virtuoso Dueling
        weaponType: Dual wield
        outdated: true

      # - name: Condi Virtuoso (sharpening sorrow)
      #   id: cvirt-sorrow
      #   specialization: Virtuoso
      #   boonType: Condi
      #   priority: Condi DPS Rampager
      #   distribution: Condi Virtuoso (sharpening sorrow)
      #   traits: Condi Virtuoso (sharpening sorrow)
      #   extras: Condi Virtuoso Dueling
      #   weaponType: Dual wield

      - name: Condi Virtuoso Chaos
        id: cvirt-chaos
        specialization: Virtuoso
        boonType: Condi
        priority: Condi DPS Rampager
        distribution: Condi Virtuoso Chaos
        traits: Condi Virtuoso Chaos
        extras: Condi Virtuoso Chaos
        weaponType: Dual wield
        outdated: true

      - name: Power Virtuoso Spear
        id: pvirt-spear
        specialization: Virtuoso
        boonType: Power
        priority: Power DPS (no dragon)
        distribution: Power Virtuoso Spear
        traits: Power Virtuoso Spear
        fractal:
          extras: Power (Fractal)
        raid:
          extras: Power (Raid, furious)
        weaponType: Two-handed
        outdated: true

      - name: Power Virtuoso GS
        id: pvirt-gs
        specialization: Virtuoso
        boonType: Power
        priority: Power DPS (no dragon)
        distribution: Power Virtuoso GS
        traits: Power Virtuoso GS
        fractal:
          extras: Power (Fractal)
        raid:
          extras: Power (Raid, furious)
        weaponType: Two-handed
        outdated: true

      - name: Boon Condi Chrono Staff SC/D
        id: condi-chrono-staff-scepter-boon
        specialization: Chronomancer
        boonType: Condi
        priority: Condi Boon 0%
        distribution: Boon Condi Chrono Staff SC/D
        traits: Boon Condi Chrono Staff SC/D
        extras: Condi Chrono Staff SC/D
        weaponType: Two-handed
        outdated: true

      - name: Boon Condi Chrono Scepter
        id: condi-chrono-stm
        specialization: Chronomancer
        boonType: Condi
        priority: Condi Boon 0%
        distribution: Boon Condi Chrono Scepter
        traits: Boon Condi Chrono Scepter
        extras: Boon Condi Chrono Scepter
        weaponType: Dual wield
        outdated: true

      - name: Boon Power Chrono DT Spear
        id: pchrono-boon-dt-spear
        specialization: Chronomancer
        boonType: Power
        priority: Power DPS (no dragon)
        distribution: Boon Power Chrono DT Spear
        traits: Boon Power Chrono DT Spear
        fractal:
          extras: Boon Power Chrono (Fractal)
        raid:
          extras: Boon Power Chrono (Raid)
        weaponType: Two-handed
        outdated: true

      - name: Boon Power Chrono IA Spear
        id: pchrono-boon-ia-spear
        specialization: Chronomancer
        boonType: Power
        priority: Power DPS (no dragon)
        distribution: Boon Power Chrono IA Spear
        traits: Boon Power Chrono IA Spear
        fractal:
          extras: Boon Power Chrono (Fractal)
        raid:
          extras: Boon Power Chrono (Raid)
        weaponType: Two-handed
        outdated: true

      - name: Boon Power Chrono GS
        id: pchrono-boon-gs
        specialization: Chronomancer
        boonType: Power
        priority: Power DPS (no dragon)
        distribution: Boon Power Chrono GS
        traits: Boon Power Chrono GS
        fractal:
          extras: Power Boon (Fractal)
        raid:
          extras: Power Boon (Raid)
        weaponType: Two-handed
        outdated: true

      - name: Condi Chrono Staff SC/D
        id: condi-chrono-staff-scepter
        specialization: Chronomancer
        boonType: Condi
        priority: Condi Boon 0%
        distribution: Condi Chrono Staff SC/D
        traits: Condi Chrono Staff SC/D
        extras: Condi Chrono Staff SC/D
        weaponType: Two-handed
        outdated: true

      - name: Condi Chrono Scepter
        id: condi-chrono-scepter
        specialization: Chronomancer
        boonType: Condi
        priority: Condi DPS
        distribution: Condi Chrono Scepter (Approx.)
        traits: Condi Chrono Scepter
        extras: Condi Chrono Scepter (Approx.)
        weaponType: Dual wield
        outdated: true

      # - name: Alacrity Power Chrono GS
      #   id: pchrono-alac-gs
      #   specialization: Chronomancer
      #   boonType: Power
      #   priority: Boon Power Chrono 0%
      #   distribution: Alacrity Power Chrono GS
      #   traits: Alacrity Power Chrono GS
      #   fractal:
      #     extras: Power Boon (Fractal)
      #   raid:
      #     extras: Power Boon (Raid)
      #   weaponType: Two-handed
      #   outdated: true

      - name: Power Chrono DT Spear
        id: pchrono-dt-spear
        specialization: Chronomancer
        boonType: Power
        priority: Power DPS (no dragon)
        distribution: Power Chrono DT Spear
        traits: Power Chrono DT Spear
        fractal:
          extras: Power Chrono DT (Fractal)
        raid:
          extras: Power Chrono DT (Raid)
        weaponType: Two-handed
        outdated: true

      - name: Power Chrono IA Spear
        id: pchrono-ia-spear
        specialization: Chronomancer
        boonType: Power
        priority: Power DPS (no dragon)
        distribution: Power Chrono IA Spear
        traits: Power Chrono IA Spear
        fractal:
          extras: Power Chrono IA (Fractal)
        raid:
          extras: Power Chrono IA (Raid)
        weaponType: Two-handed
        outdated: true

      - name: Power Chrono IA GS
        id: pchrono-ia-gs
        specialization: Chronomancer
        boonType: Power
        priority: Power DPS (no dragon)
        distribution: Power Chrono IA GS
        traits: Power Chrono IA GS
        fractal:
          extras: Power (Fractal)
        raid:
          extras: Power (Raid, furious)
        weaponType: Two-handed
        outdated: true

      # - name: Power Chrono DT Focus
      #   id: pchrono-dt-focus
      #   specialization: Chronomancer
      #   boonType: Power
      #   priority: Power DPS (no dragon)
      #   distribution: Power Chrono DT Focus
      #   traits: Power Chrono DT Focus
      #   fractal:
      #     extras: Power (Fractal)
      #   raid:
      #     extras: Power (Raid, furious)
      #   weaponType: Two-handed
      #   outdated: true

      # - name: Power Chrono IA Focus
      #   id: pchrono-ia-focus
      #   specialization: Chronomancer
      #   boonType: Power
      #   priority: Power DPS (no dragon)
      #   distribution: Power Chrono IA Focus
      #   traits: Power Chrono IA Focus
      #   fractal:
      #     extras: Power (Fractal)
      #   raid:
      #     extras: Power (Raid, furious)
      #   weaponType: Two-handed
      #   outdated: true

      - name: Alacrity Condi Mirage Staxe IH Oasis
        id: condi-staxe-mirage-alac
        specialization: Mirage
        boonType: Condi
        priority: Condi DPS
        distribution: Condi Mirage Staxe IH Oasis
        traits: Alacrity Condi Mirage Staxe IH Oasis
        extras: DPS Mirage (Raid)
        weaponType: Two-handed
        outdated: true

      - name: Alacrity Condi Mirage Staff (Approx.)
        id: alacmirage
        specialization: Mirage
        boonType: Condi
        priority: Condi Boon 0%
        distribution: Alacrity Condi Mirage Staff
        traits: Alacrity Condi Mirage Staff
        extras: Alacrity Condi Mirage Staff
        weaponType: Two-handed
        outdated: true

      - name: Condi Mirage Staxe IH Oasis
        id: condi-staxe-mirage
        specialization: Mirage
        boonType: Condi
        priority: Condi DPS
        distribution: Condi Mirage Staxe IH Oasis
        traits: Condi Mirage Staxe IH Oasis
        extras: DPS Mirage (Raid)
        weaponType: Two-handed
        outdated: true

      - name: Condi Axe Mirage
        id: axe-mirage-deception-torch
        specialization: Mirage
        boonType: Condi
        priority: Condi DPS
        distribution: Axe Mirage (Deception Torch)
        traits: Axe Mirage
        extras: DPS Mirage (Raid)
        weaponType: Dual wield
        outdated: true

      - name: Power Mirage
        id: mirage-power
        specialization: Mirage
        boonType: Power
        priority: Power DPS
        distribution: Power Mirage
        traits: Power Mirage
        fractal:
          extras: Power Mirage (Fractal)
        raid:
          extras: Power Mirage (Raid)
        weaponType: Two-handed
        outdated: true

      - name: Heal Boon Chrono
        id: heal-boon-chrono
        specialization: Chronomancer
        boonType: Power
        fractal:
          priority: Heal (Fractal)
        raid:
          priority: Heal (Raid)
        distribution: None
        traits: Heal Chrono
        extras: Heal
        weaponType: Two-handed
        outdated: true

  - class: Guardian
    builds:

      - name: Power Luminary SP/GS
        id: luminary-power
        specialization: Luminary
        boonType: Power
        priority: Power DPS
        distribution: Power Luminary SP/GS
        traits: Power Luminary
        fractal:
          extras: Power (Fractal, claw)
        raid:
          extras: Power (Raid, claw)
        weaponType: Two-handed
        outdated: true

      - name: Alacrity Power Luminary LB/GS
        id: luminary-power-alac
        specialization: Luminary
        boonType: Power
        priority: Power Alacrity Luminary 24%
        distribution: Alacrity Power Luminary LB/GS
        traits: Alacrity Power Luminary
        fractal:
          extras: Power (Fractal, claw)
        raid:
          extras: Power (Raid, claw)
        weaponType: Two-handed
        outdated: true

      # - name: Quickness Condi Firebrand 40%
      #   id: cqfb-firebrand-40
      #   specialization: Firebrand
      #   boonType: Condi
      #   priority: Condi Quickbrand 40%
      #   distribution: Condi Quickbrand (LL, Allies, Approx.)
      #   traits: Condi Quickbrand LL
      #   extras: Condi Quickbrand
      #   weaponType: Dual wield
      #   outdated: true

      # - name: Quickness Condi Firebrand 49%
      #   id: cqfb-firebrand-49
      #   specialization: Firebrand
      #   boonType: Condi
      #   priority: Condi Quickbrand 49
      #   distribution: Condi Quickbrand (WT, Allies)
      #   traits: Condi Quickbrand WT
      #   extras: Condi Quickbrand
      #   weaponType: Dual wield
      #   outdated: true

      - name: Quickness Condi Firebrand P/T P/P
        id: firebrand-condi-quickness
        specialization: Firebrand
        boonType: Condi
        priority: Condi Quickbrand 40%
        distribution: Quickness Condi Firebrand P/T P/P
        traits: Quickness Condi Firebrand P/T P/P
        extras: Quickness Condi Firebrand
        weaponType: Dual wield
        outdated: true

      - name: Quickness Power Firebrand
        id: pqfb
        specialization: Firebrand
        boonType: Power
        priority: Power Quickbrand 25%
        distribution: Power Quickbrand (approx.)
        traits: Power Quickbrand
        fractal:
          extras: Power (Fractal)
        raid:
          extras: Power Quickbrand (Raid)
        weaponType: Two-handed
        outdated: true

      # - name: CFB w/ Quickness (balthazar)
      #   id: cqfb-balth
      #   specialization: Firebrand
      #   boonType: Condi
      #   priority: Condi DPS
      #   distribution: Condi Quickbrand (allies)
      #   traits: Condi Quickbrand
      #   extras: CFB w/ Quickness (balthazar)

      # - name: CFB w/ Quickness (renegade)
      #   id: cqfb-ren
      #   specialization: Firebrand
      #   boonType: Condi
      #   priority: Condi DPS
      #   distribution: Condi Quickbrand (allies)
      #   traits: Condi Quickbrand
      #   extras: CFB w/ Quickness (renegade)

      - name: Condi Firebrand A/T P/P
        id: cfb-geo
        specialization: Firebrand
        boonType: Condi
        priority: Condi DPS
        distribution: Condi Firebrand A/T P/P (Allies)
        traits: Condi Firebrand Zeal
        extras: Condi Firebrand
        weaponType: Dual wield
        outdated: true

      - name: Condi Firebrand A/T
        id: cfb-axe-only
        specialization: Firebrand
        boonType: Condi
        priority: Condi DPS
        distribution: Condi Firebrand A/T
        traits: Condi Firebrand Zeal
        extras: Condi Firebrand
        weaponType: Dual wield
        outdated: true

      - name: Power Dragonhunter Radiance SP/GS
        id: dh-radiance
        specialization: Dragonhunter
        boonType: Power
        priority: Power DPS
        distribution: Power Dragonhunter Radiance SP/GS
        traits: Power Dragonhunter Radiance
        fractal:
          extras: Power Dragonhunter Radiance (Fractal)
        raid:
          extras: Power Dragonhunter Radiance (Raid)
        weaponType: Two-handed
        outdated: true

      - name: Power Dragonhunter Virtues SP/GS
        id: dh-virtues
        specialization: Dragonhunter
        boonType: Power
        priority: Power DPS (no dragon)
        distribution: Power Dragonhunter Virtues SP/GS
        traits: Power Dragonhunter Virtues
        fractal:
          extras: Power Dragonhunter Virtues (Fractal)
        raid:
          extras: Power Dragonhunter Virtues (Raid)
        weaponType: Two-handed
        outdated: true

      - name: Alacrity Power Willbender
        id: pwb-alac
        specialization: Willbender
        boonType: Power
        priority: Power Alacrity Willbender 14%
        distribution: Power Alacrity Willbender
        traits: Power Alacrity Willbender
        fractal:
          extras: Power Willbender Virtues (Fractal)
        raid:
          extras: Power Alacrity Willbender (Raid)
        weaponType: Two-handed
        outdated: true

      - name: Alacrity Condi Willbender
        id: cwb-alac
        specialization: Willbender
        boonType: Condi
        priority: Condi Alacrity Willbender 14%
        distribution: Condi Alacrity Willbender
        traits: Condi Alacrity Willbender
        extras: Condi Alacrity Willbender
        weaponType: Dual wield
        outdated: true

      - name: Condi Willbender P/T P/P
        id: cwb-pistol
        specialization: Willbender
        boonType: Condi
        priority: Condi DPS
        distribution: Condi Willbender P/T P/P
        traits: Condi Willbender
        extras: Condi Willbender
        weaponType: Dual wield
        outdated: true

      - name: Condi Willbender SC/P P/T
        id: cwb-scepter
        specialization: Willbender
        boonType: Condi
        priority: Condi DPS
        distribution: Condi Willbender SC/P P/T
        traits: Condi Willbender
        extras: Condi Willbender Warrior
        weaponType: Dual wield
        outdated: true

      - name: Condi Willbender GS
        id: cwb-gs
        specialization: Willbender
        boonType: Condi
        priority: Hybrid DPS
        distribution: Condi Willbender GS
        traits: Condi Willbender
        extras: Condi Willbender
        weaponType: Two-handed
        outdated: true

      - name: Power Willbender Virtues
        id: pwb-virtues
        specialization: Willbender
        boonType: Power
        priority: Power DPS (no dragon)
        distribution: Power Willbender Virtues
        traits: Power Willbender Virtues
        fractal:
          extras: Power Willbender Virtues (Fractal)
        raid:
          extras: Power (Raid, furious)
        weaponType: Two-handed
        outdated: true

      - name: Power Willbender Radiance
        id: pwb-radiance
        specialization: Willbender
        boonType: Power
        priority: Power DPS
        distribution: Power Willbender Radiance
        traits: Power Willbender Radiance
        fractal:
          extras: Power (Fractal)
        raid:
          extras: Power (Raid)
        weaponType: Two-handed
        outdated: true

      # - name: Condi Quickbrand Celestial 35%
      #   id: cqfb-cele-35
      #   specialization: Firebrand
      #   boonType: Condi
      #   priority: Condi Quickbrand 35%
      #   distribution: Condi Quickbrand (allies)
      #   traits: Condi Quickbrand
      #   extras: Condi Quickbrand 35%

      - name: Hybrid FB Virtues
        id: hycfb-virtues-leadership
        specialization: Firebrand
        boonType: Condi
        priority: Condi Hybrid Firebrand 40%
        distribution: Hybrid FB Virtues
        traits: Hybrid FB Virtues
        extras: Hybrid FB Traveler
        weaponType: Two-handed
        outdated: true

      - name: Hybrid FB Honor
        id: hycfb-honor
        specialization: Firebrand
        boonType: Condi
        priority: Condi Hybrid Firebrand 78%
        distribution: Hybrid FB (Honor, Allies)
        traits: Hybrid FB Honor
        extras: Hybrid FB Traveler
        weaponType: Two-handed
        outdated: true

      - name: Heal Quickness Firebrand
        id: hb
        specialization: Firebrand
        boonType: Power
        fractal:
          priority: Heal (Fractal)
        raid:
          priority: Heal (Raid)
        distribution: None
        traits: Heal Quickness Firebrand
        extras: Heal
        weaponType: Two-handed
        outdated: true

      - name: Heal Alacrity Willbender
        id: heal-willbender
        specialization: Willbender
        boonType: Power
        fractal:
          priority: Heal (Fractal)
        raid:
          priority: Heal (Raid)
        distribution: None
        traits: Heal Alacrity Willbender
        extras: Heal (concentration)
        weaponType: Two-handed
        outdated: true

      - name: Heal Alacrity Luminary
        id: heal-luminary
        specialization: Luminary
        boonType: Power
        fractal:
          priority: Heal (Fractal)
        raid:
          priority: Heal (Raid)
        distribution: None
        traits: Heal Alacrity Luminary
        extras: Heal (concentration)
        weaponType: Two-handed
        outdated: true

  - class: Warrior
    builds:

      - name: Hybrid Paragon S/S
        id: paragon-hybrid
        specialization: Paragon
        boonType: Condi
        priority: Hybrid DPS
        distribution: Hybrid Paragon S/S
        traits: Hybrid Paragon S/S
        extras: Hybrid Paragon S/S
        weaponType: Dual wield
        outdated: true

      - name: Alacrity Power Bladesworn Signets
        id: bls-alac-signets
        specialization: Bladesworn
        boonType: Power
        priority: Power DPS (no dragon)
        distribution: Alacrity Power Bladesworn Signets
        traits: Alacrity Power Bladesworn Signets
        fractal:
          extras: Bladesworn (Fractal, placeholder relic)
        raid:
          extras: Bladesworn (Raid, placeholder relic)
        weaponType: Dual wield
        outdated: true

      - name: Alacrity Power Bladesworn
        id: bls-alac
        specialization: Bladesworn
        boonType: Power
        priority: Power DPS (no dragon)
        distribution: Alacrity Power Bladesworn
        traits: Alacrity Power Bladesworn
        fractal:
          extras: Bladesworn (Fractal, placeholder relic)
        raid:
          extras: Bladesworn (Raid, placeholder relic)
        weaponType: Dual wield
        outdated: true

      - name: Power Bladesworn
        id: bls-dps
        specialization: Bladesworn
        boonType: Power
        priority: Power DPS (no dragon)
        distribution: Power Bladesworn
        traits: Power Bladesworn
        fractal:
          extras: Bladesworn (Fractal, placeholder relic)
        raid:
          extras: Bladesworn (Raid, placeholder relic)
        weaponType: Dual wield
        outdated: true

      - name: Quickness Condi Berserker Blademaster
        id: cbers
        specialization: Berserker
        boonType: Condi
        priority: Condi Quickness Berserker 44.7%
        distribution: Condi Quickness Berserker Blademaster
        traits: Condi Quickness Berserker Blademaster
        extras: Condi Quickness Bers
        weaponType: Two-handed
        outdated: true

      - name: Condi Berserker UF
        id: cbers-dps
        specialization: Berserker
        boonType: Condi
        priority: Condi DPS
        distribution: Condi Berserker UF
        traits: Condi Berserker UF
        extras: Condi Berserker
        weaponType: Two-handed
        outdated: true

      - name: Condi Berserker Blademaster
        id: cbers-dps-bl
        specialization: Berserker
        boonType: Condi
        priority: Condi DPS
        distribution: Condi Berserker Blademaster
        traits: Condi Berserker Blademaster
        extras: Condi Berserker
        weaponType: Two-handed
        outdated: true

      - name: Quickness Power Berserker GS A/A
        id: pbers-quick
        specialization: Berserker
        boonType: Power
        priority: Power DPS (no dragon)
        distribution: Quickness Power Berserker GS A/A
        traits: Quickness Power Berserker GS A/A
        fractal:
          extras: Power (Fractal)
        raid:
          extras: Power Berserker
        weaponType: Two-handed
        outdated: true

      - name: Power Berserker GS A/A
        id: pbers
        specialization: Berserker
        boonType: Power
        priority: Power DPS (no dragon)
        distribution: Power Berserker GS A/A
        traits: Power Berserker GS A/A
        fractal:
          extras: Power (Fractal)
        raid:
          extras: Power Berserker
        weaponType: Two-handed
        outdated: true

      - name: Power Spellbreaker S/M D/A
        id: spb-power-arms
        specialization: Spellbreaker
        boonType: Power
        priority: Power DPS (no dragon)
        distribution: Power Spellbreaker S/M D/A
        traits: Power Spellbreaker S/M D/A
        fractal:
          extras: Power (Fractal, claw)
        raid:
          extras: Power (Raid, claw)
        weaponType: Dual wield
        outdated: true

      - name: Power Spellbreaker Hammer
        id: spb-power-hammer
        specialization: Spellbreaker
        boonType: Power
        priority: Power DPS (no dragon)
        distribution: Power Spellbreaker Hammer
        traits: Power Spellbreaker Hammer
        fractal:
          extras: Power (Fractal, claw)
        raid:
          extras: Power (Raid, claw)
        weaponType: Two-handed
        outdated: true

      - name: Heal Quickness Berserker
        id: heal-berserker
        specialization: Berserker
        boonType: Power
        fractal:
          priority: Heal (Fractal)
        raid:
          priority: Heal (Raid)
        distribution: None
        traits: Heal Quickness Berserker
        extras: Heal (concentration)
        weaponType: Two-handed
        outdated: true

      - name: Heal Alacrity Paragon
        id: heal-paragon
        specialization: Paragon
        boonType: Power
        fractal:
          priority: Heal (Fractal)
        raid:
          priority: Heal (Raid)
        distribution: None
        traits: Heal Alacrity Paragon
        extras: Heal
        weaponType: Two-handed
        outdated: true

  - class: Elementalist
    builds:

      - name: Quickness Power Evoker Hare PF
        id: evoker-hare-pf-quick
        specialization: Evoker
        boonType: Power
        priority: Power DPS (no dragon)
        distribution: Power Evoker Hare PF
        traits: Quickness Power Evoker Hare PF
        fractal:
          extras: Power Evoker PF (Fractal)
        raid:
          extras: Power Evoker PF (Raid)
        weaponType: Dual wield
        outdated: true

      - name: Quickness Power Evoker Hare Inferno
        id: evoker-hare-inferno-quick
        specialization: Evoker
        boonType: Power
        priority: Berserker Only
        distribution: Power Evoker Hare Inferno
        traits: Quickness Power Evoker Hare Inferno
        fractal:
          extras: Power Evoker Hare Inferno (Fractal)
        raid:
          extras: Power Evoker Hare Inferno (Raid)
        weaponType: Dual wield
        outdated: true

      - name: Alacrity Power Evoker Toad
        id: evoker-toad-alac
        specialization: Evoker
        boonType: Power
        priority: Power DPS (no dragon)
        distribution: Alacrity Power Evoker Toad
        traits: Alacrity Power Evoker Toad
        fractal:
          extras: Power Evoker PF (Fractal)
        raid:
          extras: Power Evoker PF (Raid)
        weaponType: Dual wield
        outdated: true

      - name: Condi Evoker P/D
        id: evoker-condi-pd
        specialization: Evoker
        boonType: Condi
        priority: Condi DPS
        distribution: Condi Evoker P/D
        traits: Condi Evoker
        extras: Condi Evoker
        weaponType: Dual wield
        outdated: true

      - name: Power Evoker Hare PF
        id: evoker-hare-pf
        specialization: Evoker
        boonType: Power
        priority: Power DPS (no dragon)
        distribution: Power Evoker Hare PF
        traits: Power Evoker Hare PF
        fractal:
          extras: Power Evoker PF (Fractal)
        raid:
          extras: Power Evoker PF (Raid)
        weaponType: Dual wield
        outdated: true

      - name: Power Evoker Hare Inferno
        id: evoker-hare-inferno
        specialization: Evoker
        boonType: Power
        priority: Berserker Only
        distribution: Power Evoker Hare Inferno
        traits: Power Evoker Hare Inferno
        fractal:
          extras: Power Evoker Hare Inferno (Fractal)
        raid:
          extras: Power Evoker Hare Inferno (Raid)
        weaponType: Dual wield
        outdated: true

      - name: Quickness Fire SE Evoker Inferno
        id: fire-se-evoker-inferno
        specialization: Evoker
        boonType: Power
        priority: Berserker Only
        distribution: Fire SE Evoker Inferno
        traits: Quickness Fire SE Evoker Inferno
        fractal:
          extras: Fire SE Evoker Inferno (Fractal)
        raid:
          extras: Fire SE Evoker Inferno (Raid)
        weaponType: Dual wield
        outdated: true

      - name: Quickness Fire SE Evoker Condi (Approx.)
        id: fire-se-evoker-condi-quick
        specialization: Evoker
        boonType: Condi
        priority: Condi DPS
        distribution: Fire SE Evoker Condi (Approx.)
        traits: Quickness Fire SE Evoker Condi
        extras: Fire SE Evoker Condi
        weaponType: Dual wield
        outdated: true

      - name: Quickness Fire SE Evoker Trailblazer (Approx.)
        id: fire-se-evoker-trailblazer-quick
        specialization: Evoker
        boonType: Condi
        priority: Trailblazer/Dire
        distribution: Fire SE Evoker Trailblazer (Approx.)
        traits: Quickness Fire SE Evoker Trailblazer
        extras: Fire SE Evoker Trailblazer
        weaponType: Dual wield
        outdated: true

      - name: Fire SE Evoker Inferno
        id: fire-se-evoker-inferno-quickness
        specialization: Evoker
        boonType: Power
        priority: Berserker Only
        distribution: Fire SE Evoker Inferno
        traits: Fire SE Evoker Inferno
        fractal:
          extras: Fire SE Evoker Inferno (Fractal)
        raid:
          extras: Fire SE Evoker Inferno (Raid)
        weaponType: Dual wield
        outdated: true

      - name: Fire SE Evoker Condi (Approx.)
        id: fire-se-evoker-condi
        specialization: Evoker
        boonType: Condi
        priority: Condi DPS
        distribution: Fire SE Evoker Condi (Approx.)
        traits: Fire SE Evoker Condi
        extras: Fire SE Evoker Condi
        weaponType: Dual wield
        outdated: true

      - name: Fire SE Evoker Trailblazer (Approx.)
        id: fire-se-evoker-trailblazer
        specialization: Evoker
        boonType: Condi
        priority: Trailblazer/Dire
        distribution: Fire SE Evoker Trailblazer (Approx.)
        traits: Fire SE Evoker Trailblazer
        extras: Fire SE Evoker Trailblazer
        weaponType: Dual wield
        outdated: true

      - name: Alacrity Condi Tempest Scepter
        id: ctemp-alac
        specialization: Tempest
        boonType: Condi
        priority: Alacrity Condi Tempest 31%
        distribution: Alacrity Condi Tempest Scepter
        traits: Alacrity Condi Tempest Scepter
        extras: Condi Tempest
        weaponType: Dual wield
        outdated: true

      - name: Alacrity Fire Tempest Inferno
        id: ptemp-blood-alac
        specialization: Tempest
        boonType: Power
        priority: Alacrity Fire Tempest Inferno 22%
        distribution: Alacrity Fire Tempest Inferno
        traits: Alacrity Fire Tempest Inferno
        fractal:
          extras: Alacrity Fire Tempest Inferno (Fractal)
        raid:
          extras: Alacrity Fire Tempest Inferno (Raid)
        weaponType: Dual wield
        outdated: true

      - name: Alacrity Power Tempest Sword
        id: ptemp-alac-sw
        specialization: Tempest
        boonType: Power
        priority: Alacrity Power Tempest 34%
        distribution: Alacrity Power Tempest Sword
        traits: Alacrity Power Tempest Sword Fire
        fractal:
          extras: Power Boon (Fractal, fireworks)
        raid:
          extras: Power Boon (Raid, fireworks)
        weaponType: Dual wield
        outdated: true

      - name: Alacrity Power Tempest Hammer
        id: ptemp-alac-ham
        specialization: Tempest
        boonType: Power
        priority: Alacrity Power Tempest 31%
        distribution: Alacrity Power Tempest Hammer
        traits: Alacrity Power Tempest Hammer Fire
        fractal:
          extras: Power Boon (Fractal, fireworks)
        raid:
          extras: Power Boon (Raid, fireworks)
        weaponType: Two-handed
        outdated: true

      - name: Condi Tempest Pistol
        id: ctemp
        specialization: Tempest
        boonType: Condi
        priority: Condi Tempest
        distribution: Condi Tempest Pistol
        traits: Condi Tempest Pistol
        extras: Condi Tempest
        weaponType: Dual wield
        outdated: true

      - name: Power Tempest Inferno
        id: ptemp-blood
        specialization: Tempest
        boonType: Power
        priority: Power DPS (no dragon)
        distribution: Power Tempest Inferno
        traits: Power Tempest Inferno
        fractal:
          extras: Power Tempest Inferno (Fractal)
        raid:
          extras: Power Tempest Inferno (Raid)
        weaponType: Dual wield
        outdated: true

      - name: Fire-only Tempest (Approx.)
        id: ptemp-blood-fire-camp
        specialization: Tempest
        boonType: Power
        priority: Power DPS (no dragon)
        distribution: Fire-only Tempest (Approx.)
        traits: Fire-only Tempest
        fractal:
          extras: Alacrity Fire Tempest Inferno (Fractal)
        raid:
          extras: Alacrity Fire Tempest Inferno (Raid)
        weaponType: Dual wield
        outdated: true

      - name: Power Tempest Scepter
        id: ptemp
        specialization: Tempest
        boonType: Power
        priority: Power DPS (no dragon)
        distribution: Power Tempest Scepter
        traits: Power Tempest Water
        fractal:
          extras: Power (Fractal)
        raid:
          extras: Power (Raid)
        weaponType: Dual wield
        outdated: true

      - name: Power Weaver Sword
        id: pwea
        specialization: Weaver
        boonType: Power
        priority: Power DPS (no dragon)
        distribution: Power Weaver (BTTH, small)
        fractal:
          traits: Power Weaver Stormsoul Fractal
          extras: Power (Fractal, fireworks)
        raid:
          traits: Power Weaver Raid
          extras: Power Weaver (Raid)
        weaponType: Dual wield
        outdated: true

      - name: Condi Weaver P/D
        id: cwea-pi
        specialization: Weaver
        boonType: Condi
        priority: Condi DPS
        distribution: Condi Weaver P/D
        traits: Condi Weaver P/D
        extras: Condi Weaver
        weaponType: Dual wield
        outdated: true

      - name: Condi Weaver Staff
        id: cwea-staff
        specialization: Weaver
        boonType: Condi
        priority: Condi DPS
        distribution: Condi Weaver Staff (Large)
        traits: Condi Weaver Staff
        extras: Condi Weaver
        weaponType: Two-handed
        outdated: true

      - name: Condi Weaver Scepter
        id: cwea-scepter
        specialization: Weaver
        boonType: Condi
        priority: Condi DPS
        distribution: Condi Weaver Scepter
        traits: Condi Weaver Scepter
        extras: Condi Weaver Scepter
        weaponType: Dual wield
        outdated: true

      - name: Condi Weaver Sword
        id: cwea-sw
        specialization: Weaver
        boonType: Condi
        priority: Condi DPS
        distribution: Condi Weaver Sword
        traits: Condi Weaver Sword
        extras: Condi Weaver Sword
        weaponType: Dual wield
        outdated: true

      - name: Condi Weaver Dagger
        id: cwea-dg
        specialization: Weaver
        boonType: Condi
        priority: Condi DPS
        distribution: Condi Weaver (Dagger)
        traits: Condi Weaver Dagger
        extras: Condi Weaver Dagger
        weaponType: Dual wield
        outdated: true

      - name: Fire-only Weaver
        id: fire-only-weaver
        specialization: Weaver
        boonType: Power
        priority: Berserker Only
        distribution: Fire-only Weaver
        traits: Fire-only Weaver
        fractal:
          extras: Fire-only Weaver Inferno (Fractal)
        raid:
          extras: Fire-only Weaver Inferno (Raid)
        weaponType: Dual wield
        outdated: true

      - name: Hybrid Weaver
        id: hwea
        specialization: Weaver
        boonType: Condi
        priority: Hybrid DPS
        distribution: Hybrid Weaver
        traits: Hybrid Weaver
        fractal:
          extras: Hybrid Weaver (Fractal)
        raid:
          extras: Hybrid Weaver (Raid)
        weaponType: Dual wield
        outdated: true

      - name: Quickness Condi Catalyst P/D Steamshrieker
        id: condi-cat-quick-pd
        specialization: Catalyst
        boonType: Condi
        priority: Condi Boon
        distribution: Condi Catalyst P/D
        traits: Quickness Condi Catalyst P/D
        extras: Condi Catalyst P/D
        weaponType: Dual wield
        outdated: true

      - name: Quickness Condi Catalyst P/W
        id: condi-cat-quick-pw
        specialization: Catalyst
        boonType: Condi
        priority: Condi Boon
        distribution: Condi Catalyst P/W
        traits: Quickness Condi Catalyst P/W
        extras: Condi Catalyst P/W
        weaponType: Dual wield
        outdated: true

      - name: Quickness Power Catalyst Scepter Inferno
        id: power-cat-quick-inferno
        specialization: Catalyst
        boonType: Power
        priority: Power DPS (no dragon)
        distribution: Quickness Power Catalyst Scepter Inferno
        traits: Quickness Power Catalyst Scepter Inferno
        fractal:
          extras: Power Catalyst Scepter Inferno (Fractal)
        raid:
          extras: Power Catalyst Scepter Inferno (Raid)
        weaponType: Dual wield
        outdated: true

      - name: Quickness Power Catalyst Scepter PF
        id: power-cat-quick
        specialization: Catalyst
        boonType: Power
        priority: Power DPS (no dragon)
        distribution: Quickness Power Catalyst Scepter PF
        traits: Quickness Power Catalyst Scepter PF
        fractal:
          extras: Power Catalyst Scepter PF (Fractal)
        raid:
          extras: Power Catalyst Scepter PF (Raid)
        weaponType: Dual wield
        outdated: true

      - name: Condi Catalyst P/D Steamshrieker (Approx.)
        id: condi-cat-pd
        specialization: Catalyst
        boonType: Condi
        priority: Condi DPS
        distribution: Condi Catalyst P/D
        traits: Condi Catalyst P/D
        extras: Condi Catalyst P/D
        weaponType: Dual wield
        outdated: true

      - name: Power Catalyst Scepter Inferno
        id: power-cat-inferno
        specialization: Catalyst
        boonType: Power
        priority: Power DPS (no dragon)
        distribution: Power Catalyst Scepter Inferno
        traits: Power Catalyst Scepter Inferno
        fractal:
          extras: Power Catalyst Scepter Inferno (Fractal)
        raid:
          extras: Power Catalyst Scepter Inferno (Raid)
        weaponType: Dual wield
        outdated: true

      - name: Power Catalyst Scepter PF
        id: power-cat
        specialization: Catalyst
        boonType: Power
        priority: Power DPS (no dragon)
        distribution: Power Catalyst Scepter PF
        traits: Power Catalyst Scepter PF
        fractal:
          extras: Power Catalyst Scepter PF (Fractal)
        raid:
          extras: Power Catalyst Scepter PF (Raid)
        weaponType: Dual wield
        outdated: true

      - name: Heal Quickness Catalyst
        id: healcat
        specialization: Catalyst
        boonType: Power
        fractal:
          priority: Heal (Fractal)
        raid:
          priority: Heal (Raid)
        distribution: None
        traits: Heal Quickness Catalyst
        extras: Heal
        weaponType: Dual wield
        outdated: true

      - name: Heal Alacrity Tempest
        id: healtemp
        specialization: Tempest
        boonType: Power
        fractal:
          priority: Heal (Fractal)
        raid:
          priority: Heal (Raid)
        distribution: None
        traits: Heal Alacrity Tempest
        extras: Heal
        weaponType: Dual wield
        outdated: true

      - name: Heal Alacrity Evoker
        id: healevoker
        specialization: Evoker
        boonType: Power
        fractal:
          priority: Heal (Fractal)
        raid:
          priority: Heal (Raid)
        distribution: None
        traits: Heal Alacrity Evoker
        extras: Heal
        weaponType: Dual wield
        outdated: true

  - class: Ranger
    builds:

      - name: Power Galeshot
        id: galeshot-power
        specialization: Galeshot
        boonType: Power
        priority: Power DPS
        distribution: Power Galeshot
        traits: Power Galeshot
        fractal:
          extras: Power (Fractal, claw)
        raid:
          extras: Power Galeshot (Raid)
        weaponType: Two-handed
        outdated: true

      - name: Quickness Condi Untamed
        id: condi-quickness-untamed
        specialization: Untamed
        boonType: Condi
        priority: Quickness Condi Untamed 42%
        distribution: Quickness Condi Untamed
        traits: Quickness Condi Untamed
        extras: Quickness Condi Untamed
        weaponType: Dual wield
        outdated: true

      - name: Quickness Power Untamed HA S/A NM
        id: quickness-power-untamed
        specialization: Untamed
        boonType: Power
        priority: Power Quickness Untamed 40%
        distribution: Quickness Power Untamed HA S/A NM
        traits: Quickness Power Untamed HA S/A NM
        fractal:
          extras: Power (Fractal)
        raid:
          extras: Power Quickness Untamed (Raid)
        weaponType: Two-handed
        outdated: true

      - name: Power Untamed HA S/A
        id: power-untamed
        specialization: Untamed
        boonType: Power
        priority: Power DPS
        distribution: Power Untamed HA S/A
        traits: Power Untamed
        fractal:
          extras: Power Untamed (Fractal)
        raid:
          extras: Power Untamed (Raid)
        weaponType: Two-handed
        outdated: true

      - name: Power Soulbeast
        id: pslb
        specialization: Soulbeast
        boonType: Power
        priority: Power DPS
        distribution: Power Soulbeast
        traits: Power Soulbeast
        fractal:
          extras: Power (Fractal, fireworks)
        raid:
          extras: Power (Raid, fireworks)
        weaponType: Two-handed
        outdated: true

      - name: Hybrid Soulbeast A/T D/A (Approx.)
        id: hslb
        specialization: Soulbeast
        boonType: Condi
        priority: Hybrid DPS
        distribution: Hybrid Slb A/T D/A
        traits: Hybrid Slb
        extras: Hybrid Slb
        weaponType: Dual wield
        outdated: true

      # - name: Condi Soulbeast D/T SB
      #   id: cslb-sb
      #   specialization: Soulbeast
      #   boonType: Condi
      #   priority: Condi DPS
      #   distribution: Condi Slb (D/T SB)
      #   traits: Condi Slb SB
      #   extras: Condi Slb
      #   weaponType: Two-handed
      #   outdated: true

      # - name: Condi Soulbeast D/T A/D
      #   id: cslb-dtad
      #   specialization: Soulbeast
      #   boonType: Condi
      #   priority: Condi DPS
      #   distribution: Condi Slb (D/T A/D)
      #   traits: Condi Slb D/T A/D

      - name: Condi Soulbeast D/D SB (Approx.)
        id: cslb-ddsb
        specialization: Soulbeast
        boonType: Condi
        priority: Condi DPS
        distribution: Condi Slb D/D SB
        traits: Condi Slb D/D SB
        extras: Condi Slb
        weaponType: Dual wield
        outdated: true

      - name: Condi Druid LOYF
        id: condidruid
        specialization: Druid
        boonType: Condi
        priority: Condi DPS
        distribution: Condi Druid LOYF
        traits: Condi Druid LOYF
        extras: Condi Druid
        weaponType: Dual wield
        outdated: true

      - name: Heal Quickness Untamed
        id: healuntamed
        specialization: Untamed
        boonType: Power
        fractal:
          priority: Heal (Fractal)
        raid:
          priority: Heal (Raid)
        distribution: None
        traits: Heal Quickness Untamed
        extras: Heal
        weaponType: Two-handed
        outdated: true

      - name: Heal Alacrity Druid
        id: druid
        specialization: Druid
        boonType: Power
        fractal:
          priority: Heal (Fractal)
        raid:
          priority: Heal (Raid)
        distribution: None
        traits: Heal Alacrity Druid
        extras: Heal
        weaponType: Two-handed
        outdated: true

  - class: Revenant
    builds:

      - name: Condition Conduit
        id: conduit-condi
        specialization: Conduit
        boonType: Condi
        priority: Condi DPS
        distribution: Condition Conduit
        traits: Condition Conduit
        extras: Condition Conduit
        weaponType: Two-handed
        outdated: true

      - name: Condition Conduit SOTM
        id: conduit-condi-sotm
        specialization: Conduit
        boonType: Condi
        priority: Condi DPS
        distribution: Condition Conduit SOTM
        traits: Condition Conduit SOTM
        extras: Condition Conduit
        weaponType: Two-handed
        outdated: true

      - name: Power Conduit S/S PW Thief
        id: conduit-power
        specialization: Conduit
        boonType: Power
        priority: Power DPS
        distribution: Power Conduit S/S PW Thief
        traits: Power Conduit PW
        fractal:
          extras: Power (Fractal)
        raid:
          extras: Power (Raid, air)
        weaponType: Dual wield
        outdated: true

      - name: Quickness Power Herald
        id: herald-quick
        specialization: Herald
        boonType: Power
        priority: Power DPS
        distribution: Power Quickness Herald
        traits: Power Quickness Herald
        fractal:
          extras: Power Quickness Herald (Fractal)
        raid:
          extras: Power Quickness Herald (Raid)
        weaponType: Two-handed
        outdated: true

      - name: Quickness Condi Herald Spear M/A
        id: cherald-quick
        specialization: Herald
        boonType: Condi
        priority: Condi Quickness Herald 0%
        distribution: Condi Quickness Herald Spear M/A
        traits: Condi Quickness Herald
        extras: Condi Quickness Herald
        weaponType: Two-handed
        outdated: true

      - name: Quickness Condi Herald Spear
        id: cherald-quick-spearonly
        specialization: Herald
        boonType: Condi
        priority: Condi Quickness Herald 0%
        distribution: Condi Quickness Herald Spear
        traits: Condi Quickness Herald
        extras: Condi Quickness Herald
        weaponType: Two-handed
        outdated: true

      - name: Power Herald FP
        id: herald
        specialization: Herald
        boonType: Power
        priority: Power DPS
        distribution: Power Herald FP
        traits: Power Herald FP
        fractal:
          extras: Power (Fractal)
        raid:
          extras: Power (Raid, air)
        weaponType: Dual wield
        outdated: true

      - name: Alacrity Condi Renegade Spear M/A
        id: cren-alac-spear-mace
        specialization: Renegade
        boonType: Condi
        priority: Alacrity Condi Renegade 42%
        distribution: Alacrity Condi Renegade Spear M/A (Allies)
        traits: Alacrity Condi Renegade Invo
        extras: Alacrity Condi Renegade
        weaponType: Two-handed
        outdated: true

      - name: Alacrity Condi Renegade SB M/A
        id: cren-alac-invo
        specialization: Renegade
        boonType: Condi
        priority: Alacrity Condi Renegade 42%
        distribution: Alacrity Condi Renegade SB M/A
        traits: Alacrity Condi Renegade Invo
        extras: Alacrity Condi Renegade
        weaponType: Two-handed
        outdated: true

      - name: Alacrity Power Renegade
        id: pren
        specialization: Renegade
        boonType: Power
        priority: Alacrity Power Renegade 37.4%
        distribution: Alacrity Power Renegade
        traits: Alacrity Power Renegade
        fractal:
          extras: Power (Fractal)
        raid:
          extras: Alacrity Power Renegade (Raid)
        weaponType: Two-handed
        outdated: true

      - name: Condi Renegade Spear M/A
        id: cren-spear-mace
        specialization: Renegade
        boonType: Condi
        priority: Condi DPS
        distribution: Condi Renegade Spear M/A (Allies)
        traits: Condi Renegade Invo
        extras: Condi Renegade
        weaponType: Two-handed
        outdated: true

      - name: Condi Renegade Spear
        id: cren-spear
        specialization: Renegade
        boonType: Condi
        priority: Condi DPS
        distribution: Condi Renegade Spear Only (Allies)
        traits: Condi Renegade Invo
        extras: Condi Renegade
        weaponType: Two-handed
        outdated: true

      - name: Condi Renegade SB Invo
        id: cren-invo
        specialization: Renegade
        boonType: Condi
        priority: Condi DPS
        distribution: Condi Renegade SB Invocation
        traits: Condi Renegade Invo
        extras: Condi Renegade
        weaponType: Two-handed
        outdated: true

      - name: Power Vindicator
        id: vindi
        specialization: Vindicator
        boonType: Power
        priority: Power DPS
        distribution: DPS Vindicator
        traits: DPS Vindicator
        fractal:
          extras: DPS Vindicator (Fractal)
        raid:
          extras: DPS Vindicator (Raid)
        weaponType: Two-handed
        outdated: true

      - name: Heal Alacrity Renegade
        id: healren
        specialization: Renegade
        boonType: Power
        fractal:
          priority: Heal (Fractal)
        raid:
          priority: Heal (Raid)
        distribution: None
        traits: Heal Ren
        extras: Heal
        weaponType: Two-handed
        outdated: true

      - name: Heal Quickness Herald
        id: heal-herald
        specialization: Herald
        boonType: Power
        fractal:
          priority: Heal (Fractal)
        raid:
          priority: Heal (Raid)
        distribution: None
        traits: Heal Herald
        extras: Heal
        weaponType: Two-handed
        outdated: true

  - class: Engineer
    builds:

      - name: Alacrity Power Amalgam (Approx.)
        id: amalgam-power-alac
        specialization: Amalgam
        boonType: Power
        priority: Power DPS
        distribution: Alacrity Power Amalgam
        traits: Alacrity Power Amalgam Silver Lining
        fractal:
          extras: Power (Fractal, bloodstone 0.6)
        raid:
          extras: Power (Raid, bloodstone 0.6)
        weaponType: Two-handed
        outdated: true

      - name: Alacrity Condi Amalgam 2 Kit
        id: amalgam-condi-alac
        specialization: Amalgam
        boonType: Condi
        priority: Condi DPS
        distribution: Alacrity Condi Amalgam 2 Kit
        traits: Alacrity Condi Amalgam 2 Kit
        extras: Condi Amalgam
        weaponType: Two-handed
        outdated: true

      - name: Alacrity Condi Amalgam 4 Kit
        id: amalgam-condi-alac-steamshrieker
        specialization: Amalgam
        boonType: Condi
        priority: Condi DPS
        distribution: Alacrity Condi Amalgam 4 Kit
        traits: Alacrity Condi Amalgam 4 Kit
        extras: Condi Amalgam Steamshrieker
        weaponType: Two-handed
        outdated: true

      - name: Quickness Power Scrapper (Approx.)
        id: pqscrap
        specialization: Scrapper
        boonType: Power
        priority: Power DPS
        distribution: Power Scrapper
        traits: Quickness Power Scrapper
        fractal:
          extras: Power (Fractal, fireworks)
        raid:
          extras: Power (Raid, fireworks)
        weaponType: Two-handed
        outdated: true

      - name: Quickness Condi Scrapper
        id: cqscrap
        specialization: Scrapper
        boonType: Condi
        priority: Condi DPS
        distribution: Quickness Condi Scrapper Steamshrieker
        traits: Quickness Condi Scrapper
        extras: Quickness Condi Scrapper
        weaponType: Two-handed
        outdated: true

      - name: Power Scrapper (Approx.)
        id: pscrap
        specialization: Scrapper
        boonType: Power
        priority: Power DPS
        distribution: Power Scrapper
        traits: Power Scrapper
        fractal:
          extras: Power (Fractal, fireworks)
        raid:
          extras: Power (Raid, fireworks)
        weaponType: Two-handed
        outdated: true

      - name: Power Holo ECSU (Approx.)
        id: pholo-ecsu
        specialization: Holosmith
        boonType: Power
        priority: Power DPS
        distribution: Power Holo ECSU
        traits: Power Holo ECSU
        fractal:
          extras: Power (Fractal)
        raid:
          extras: Power Holo (Raid)
        weaponType: Dual wield
        outdated: true

      - name: Power Holo PBM (Approx.)
        id: pholo-pbm
        specialization: Holosmith
        boonType: Power
        priority: Power DPS
        distribution: Power Holo PBM
        traits: Power Holo PBM
        fractal:
          extras: Power (Fractal)
        raid:
          extras: Power Holo (Raid)
        weaponType: Two-handed
        outdated: true

      - name: Condi Holosmith Spear
        id: cholo
        specialization: Holosmith
        boonType: Condi
        priority: Condi DPS
        distribution: Condi Holo
        traits: Condi Holo
        extras: Condi Holo
        weaponType: Two-handed
        outdated: true

      # - name: Condi Mech J-Drive (Approx.)
      #   id: cmech-sig-mace
      #   specialization: Mechanist
      #   boonType: Condi
      #   priority: Condi DPS
      #   distribution: Condi Mechanist J-Drive (approx.)
      #   traits: Condi Mechanist J-Drive
      #   extras: Condi Mechanist
      #   weaponType: Dual wield
      #   outdated: false

      # - name: Condi Mech Jade Dynamo (Approx.)
      #   id: cmech-dynamo-pistol
      #   specialization: Mechanist
      #   boonType: Condi
      #   priority: Condi DPS
      #   distribution: Condi Mechanist Jade Dynamo Pistol (approx.)
      #   traits: Condi Mechanist Jade Dynamo
      #   extras: Condi Mechanist
      #   weaponType: Dual wield
      #   outdated: true

      # - name: Condi Alac Mech (inaccurate)
      #   id: cmech-alac-condi
      #   specialization: Mechanist
      #   boonType: Condi
      #   priority: Condi Alacrity Mechanist 50%
      #   distribution: Condi Alac Mechanist (inaccurate)
      #   traits: Condi Alac Mechanist (inaccurate)
      #   extras: Condi Alac Mechanist (inaccurate)
      #   weaponType: Dual wield
      #   outdated: true

      - name: Heal Quickness Scrapper
        id: healscrapper
        specialization: Scrapper
        boonType: Power
        fractal:
          priority: Heal (Fractal)
        raid:
          priority: Heal (Raid)
        distribution: None
        traits: Heal Quickness Scrapper
        extras: Heal
        weaponType: Dual wield
        outdated: true

      - name: Heal Alacrity Mechanist
        id: healmech
        specialization: Mechanist
        boonType: Power
        fractal:
          priority: Heal (Fractal)
        raid:
          priority: Heal (Raid)
        distribution: None
        traits: Heal Alacrity Mechanist
        extras: Heal
        weaponType: Dual wield
        outdated: true

      - name: Heal Alacrity Amalgam
        id: healamalgam
        specialization: Amalgam
        boonType: Power
        fractal:
          priority: Heal (Fractal)
        raid:
          priority: Heal (Raid)
        distribution: None
        traits: Heal Alacrity Amalgam
        extras: Heal
        weaponType: Dual wield
        outdated: true

  - class: Necromancer
    builds:

      - name: Power Ritualist (Approx.)
        id: ritualist-power
        specialization: Ritualist
        boonType: Power
        priority: Power DPS (no dragon)
        distribution: Power Ritualist
        traits: Power Ritualist
        fractal:
          extras: Power (Fractal, claw)
        raid:
          extras: Power (Raid, claw)
        weaponType: Two-handed
        outdated: true

      - name: Quickness Condi Harbinger
        id: qharb
        specialization: Harbinger
        boonType: Condi
        priority: Condi Quickness Harbinger 12.8%
        distribution: Quickness Condi Harbinger
        traits: Quickness Condi Harbinger
        extras: Quickness Condi Harbinger
        weaponType: Dual wield
        outdated: true

      - name: Quickness Power Harbinger
        id: qharb-power
        specialization: Harbinger
        boonType: Power
        priority: Power DPS (no dragon)
        distribution: Quickness Power Harbinger
        traits: Quickness Power Harbinger
        fractal:
          extras: Power (Fractal, fireworks)
        raid:
          extras: Power (Raid, fireworks)
        weaponType: Two-handed
        outdated: true

      - name: Condi Harbinger
        id: charb
        specialization: Harbinger
        boonType: Condi
        priority: Condi DPS
        distribution: DPS Harbinger
        traits: DPS Harbinger
        extras: DPS Harbinger
        weaponType: Dual wield
        outdated: true

      - name: Power Harbinger
        id: pharb
        specialization: Harbinger
        boonType: Power
        priority: Power DPS (no dragon)
        distribution: Power Harbinger
        traits: Power Harbinger
        fractal:
          extras: Power (Fractal, fireworks)
        raid:
          extras: Power (Raid, fireworks)
        weaponType: Two-handed
        outdated: true

      - name: Alacrity Condi Scourge
        id: scourge-alac
        specialization: Scourge
        boonType: Condi
        priority: Condi Alacrity Scourge 28.8%
        distribution: Condi Alacrity Scourge
        traits: Condi Alacrity Scourge
        extras: DPS Scourge
        weaponType: Dual wield
        outdated: true

      - name: Condi Scourge
        id: scourge
        specialization: Scourge
        boonType: Condi
        priority: Condi DPS
        distribution: Condi Scourge
        traits: DPS Scourge
        extras: DPS Scourge
        weaponType: Dual wield
        outdated: true

      - name: Power Reaper
        id: preaper
        specialization: Reaper
        boonType: Power
        priority: Power DPS
        distribution: Power Reaper
        traits: Power Reaper
        fractal:
          extras: Power (Fractal, fireworks)
        raid:
          extras: Power (Raid, fireworks)
        weaponType: Two-handed
        outdated: true

      - name: Condi Reaper Spear
        id: creaper-spear
        specialization: Reaper
        boonType: Condi
        priority: Hybrid DPS
        distribution: Condi Reaper Spear
        traits: Condi Reaper Spear
        extras: Condi Reaper Spear
        weaponType: Two-handed
        outdated: true

      - name: Condi Reaper Scepter
        id: creaper
        specialization: Reaper
        boonType: Condi
        priority: Hybrid DPS
        distribution: Condi Reaper Scepter
        traits: Condi Reaper Scepter
        extras: Condi Reaper Scepter
        weaponType: Two-handed
        outdated: true

      - name: Heal Quickness Ritualist
        id: healrit
        specialization: Ritualist
        boonType: Power
        fractal:
          priority: Heal (Fractal)
        raid:
          priority: Heal (Raid)
        distribution: None
        traits: Heal Quickness Ritualist
        extras: Heal
        weaponType: Two-handed
        outdated: true

      - name: Heal Alacrity Scourge
        id: healscourge
        specialization: Scourge
        boonType: Power
        fractal:
          priority: Heal (Fractal)
        raid:
          priority: Heal (Raid)
        distribution: None
        traits: Heal Alacrity Scourge
        extras: Heal
        weaponType: Two-handed
        outdated: true

  - class: Thief
    builds:

      - name: Alacrity Power Antiquary Spear
        id: antiq-alac-power-spear
        specialization: Antiquary
        boonType: Power
        priority: Alacrity Power Antiquary 13%
        distribution: Alacrity Power Antiquary Spear
        traits: Alacrity Power Antiquary Spear
        fractal:
          extras: Power Boon (Fractal, claw)
        raid:
          extras: Power Boon (Raid, claw)
        weaponType: Two-handed
        outdated: true

      - name: Condi Antiquary Spear
        id: antiq-condi-spear
        specialization: Antiquary
        boonType: Condi
        priority: Condi DPS
        distribution: Condi Antiquary Spear (Allies)
        traits: Condi Antiquary Spear
        extras: Condi Antiquary Spear Generosity
        weaponType: Two-handed
        outdated: true

      - name: Alacrity Condi Specter SC/D (Approx.)
        id: specter-alac
        specialization: Specter
        boonType: Condi
        priority: Alacrity Condi Specter 32.8%
        distribution: Alacrity Condi Specter SC/D (allies)
        traits: Alacrity Condi Specter SC/D
        extras: Alacrity Condi Specter
        weaponType: Dual wield
        outdated: true

      - name: Alacrity Condi Specter D/D
        id: specter-alac-dd
        specialization: Specter
        boonType: Condi
        priority: Alacrity Condi Specter 32.8%
        distribution: Alacrity Condi Specter D/D (allies)
        traits: Alacrity Condi Specter D/D
        extras: Alacrity Condi Specter
        weaponType: Dual wield
        outdated: true

      - name: Condi Specter Spear
        id: specter-spear
        specialization: Specter
        boonType: Condi
        priority: Condi DPS
        distribution: Condi Specter Spear (Allies)
        traits: Condi Specter Spear
        extras: Condi Specter Spear
        weaponType: Two-handed
        outdated: true

      - name: Condi Specter SC/D
        id: specter
        specialization: Specter
        boonType: Condi
        priority: Condi DPS
        distribution: Condi Specter SC/D (Allies)
        traits: Condi Specter SC/D
        extras: Condi Specter SC/D
        weaponType: Dual wield
        outdated: true

      - name: Condi Barrier "Carrion" Specter SC/D
        id: specter-carrion
        specialization: Specter
        boonType: Condi
        priority: Condi Barrier Specter
        distribution: DPS Barrier Specter SC/D (Allies)
        traits: Condi Specter SC/D
        extras: Condi Barrier Specter SC/D
        weaponType: Dual wield
        outdated: true

      - name: Boon Power Daredevil Staff
        id: boondd-power
        specialization: Daredevil
        boonType: Power
        priority: Power Boon Daredevil 99.7%
        distribution: Power Daredevil Staff
        traits: Power Boon Daredevil
        extras: Power Boon Daredevil
        weaponType: Two-handed
        outdated: true

      - name: Condi Daredevil D/D
        id: cdd
        specialization: Daredevil
        boonType: Condi
        priority: Condi DPS
        distribution: Condi Daredevil D/D
        traits: Condi Daredevil D/D
        extras: Condi Daredevil D/D
        weaponType: Dual wield
        outdated: true

      - name: Power Daredevil Staff
        id: staffdd
        specialization: Daredevil
        boonType: Power
        priority: Power DPS
        distribution: Power Daredevil Staff
        traits: Power Daredevil Staff
        fractal:
          extras: Power (Fractal)
        raid:
          extras: Power Daredevil Staff
        weaponType: Two-handed
        outdated: true

      - name: Quickness Condi Deadeye Spear
        id: quick-cded-spear
        specialization: Deadeye
        boonType: Condi
        priority: Condi DPS
        distribution: Quickness Condi Deadeye Spear
        traits: Quickness Condi Deadeye Spear
        extras: Quickness Condi Deadeye Spear
        weaponType: Two-handed
        outdated: true

      - name: Quickness Power Deadeye Spear
        id: quick-pded-spear
        specialization: Deadeye
        boonType: Power
        priority: Power DPS (no dragon)
        distribution: Quickness Power Deadeye Spear
        traits: Quickness Power Deadeye Spear
        fractal:
          extras: Power (Fractal)
        raid:
          extras: Power Deadeye (Raid)
        weaponType: Two-handed
        outdated: true

      - name: Condi Deadeye A/D
        id: cded
        specialization: Deadeye
        boonType: Condi
        priority: Condi DPS
        distribution: Condi Deadeye A/D
        traits: Condi Deadeye A/D
        extras: Condi Deadeye A/D
        weaponType: Dual wield
        outdated: true

      - name: Power Deadeye Rifle
        id: pded-m7
        specialization: Deadeye
        boonType: Power
        priority: Power DPS (no dragon)
        distribution: Power Deadeye Rifle
        traits: Power Deadeye Rifle
        fractal:
          extras: Power (Fractal)
        raid:
          extras: Power Deadeye (Raid)
        weaponType: Two-handed
        outdated: true

      - name: Power Deadeye Spear
        id: pded-spear
        specialization: Deadeye
        boonType: Power
        priority: Power DPS (no dragon)
        distribution: Power Deadeye Spear
        traits: Power Deadeye Spear
        fractal:
          extras: Power (Fractal)
        raid:
          extras: Power Deadeye (Raid)
        weaponType: Two-handed
        outdated: true

      # - name: Power Deadeye Daggers BQoBK
      #   id: pded-daggers-bqobk
      #   specialization: Deadeye
      #   boonType: Power
      #   priority: Power DPS (no dragon)
      #   distribution: Power Deadeye Daggers BQoBK
      #   traits: Power Deadeye Daggers BQoBK
      #   fractal:
      #     extras: Power (Fractal)
      #   raid:
      #     extras: Power (Raid)
      #   weaponType: Dual wield
      #   outdated: true

      - name: Power Deadeye Rifle Silent Scope
        id: rifleded-silent
        specialization: Deadeye
        boonType: Power
        priority: Power DPS (no dragon)
        distribution: Power Deadeye Rifle Silent Scope
        traits: Power Deadeye Rifle Silent Scope
        fractal:
          extras: Power (Fractal)
        raid:
          extras: Power (Raid)
        weaponType: Two-handed
        outdated: true

      - name: Condi Thief Spear
        id: cthief-spear
        specialization: Thief
        boonType: Condi
        priority: Condi DPS
        distribution: Condi Thief Spear
        traits: Condi Thief Spear
        extras: Condi Thief Spear
        weaponType: Two-handed
        outdated: true

      - name: Condi Thief A/D (Approx.)
        id: cthief-axe
        specialization: Thief
        boonType: Condi
        priority: Condi DPS
        distribution: Condi Thief A/D
        traits: Condi Thief A/D
        extras: Condi Thief A/D
        weaponType: Dual wield
        outdated: true

      - name: Heal Alacrity Specter
        id: heal-specter
        specialization: Specter
        boonType: Power
        priority: Heal Specter 88%
        distribution: None
        traits: Heal Specter
        extras: Heal
        weaponType: Dual wield
        outdated: true
